import { breakpointDown } from './utils/breakpoints'

let section = document.querySelector('#hero-content-right .section-animate-skew');

let currentPos = window.pageYOffset;
let skewAnimate = false
let isScrolling = true

function update() {

  const newPos = window.pageYOffset;
  const diff = newPos - currentPos;
  let speed = diff * 0.125;

  let value = speed > 2 ? 2 : speed
      value = value < -2 ? -2 : value

  section.style.transform = `skewY(${ value }deg)`;

  currentPos = newPos;

  if(skewAnimate && isScrolling) {
    requestAnimationFrame(update);
  }

  if(diff === 0) {
    isScrolling = false
  }

}

window.onscroll = () => {
  if(!isScrolling) {
    isScrolling = true
    requestAnimationFrame(update);
  }
}

function runSkew(sectionID)
{
  if(breakpointDown('lg')) return false

  stopSkew()

  if(sectionID) {
    section = document.querySelector('#'+sectionID+' .section-animate-skew')
    if(section) {
      skewAnimate = true
      requestAnimationFrame(update)
    }
  }

}

function stopSkew()
{
  skewAnimate = false
  section ? section.style.transform = `skewY(0deg)` : null;
}



export { runSkew, stopSkew }
